module.exports = __webpack_public_path__ + "d1d426a36640ab716bab27171994b964.svg";